import { AddRounded, ExpandLess, ExpandMore, KeyboardArrowUp, PersonRounded } from "@mui/icons-material";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import {
	attrConditionalDisplayColObj,
	attrGrpTableStrColumnsObj,
	attributeCollectionTypes,
	constraintsOptions,
	isColumnDefault,
	productionStageOptions,
	productPagePath,
} from "components/PimDashboard/data";
import { modalProfileImagesAssocObj, modalProfileFileAssocObj } from "./data";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";
import { AuthState } from "context/AuthContext";
import { inputTypes, statusOptions } from "data/globalData";
import { studioAttrGrpAttrAssocObj, studioAttrValAssocObj } from "../StudioAttributes/data";
import { useEffect, useState } from "react";
import axios from "axios";
import RenderAttributeInputs, { removeDropdownOptionsBasedonDependency } from "./RenderAttributeInputs/RenderAttributeInputs";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import RenderStyleInputField from "./RenderAttributeInputs/RenderInputField/RenderInputField";
import AddNewImageModal, { isMainImg } from "./AddImagesModal/AddImagesModal";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { departments } from "data/authData";
import { useNavigate } from "react-router-dom";
import { NAOption, fileColumns, styleImgDepartmentCol, modalProfileUrlKey } from "./data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { StudioDashboardState } from "context/StudioDashboardContext";
const imgWidth = 150;
const imgHeight = 180;

const RenderConditionalAttributeInputs = ({ columns, setData, data, width, attrGrp, setErrorObj, errorObj }) => {
	const { allAttributes } = StudioDashboardState();
	const condGrpAttrColkey = attrGrp?.data?.[attrConditionalDisplayColObj.key];
	let colCondAttr = null;
	if (condGrpAttrColkey && allAttributes) {
		let arr = allAttributes.filter((row) => row?.key === condGrpAttrColkey);
		if (arr?.length) colCondAttr = arr[0];
	}
	console.log(colCondAttr, condGrpAttrColkey, "fdghjk");
	useEffect(() => {
		if (colCondAttr) {
			let condAttrColVal = data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				? data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				: "";
			console.log(colCondAttr, condGrpAttrColkey, condAttrColVal, currentConditionalAttr, "fdghjksdf");

			if (condAttrColVal !== currentConditionalAttr) {
				if (condAttrColVal !== getColDefaultValue(colCondAttr)) {
					let a1 = [],
						a2 = [],
						a2DefValues = {},
						a1DefValues = {};
					columns?.forEach((col) => {
						console.log(
							col,
							col?.data?.[attrConditionalDisplayColObj.key]?.includes(
								data?.[colCondAttr.linked_table]?.[colCondAttr.key]
							),
							"fdghjk1"
						);
						if (
							col?.data?.[attrConditionalDisplayColObj.key]?.includes(
								data?.[colCondAttr.linked_table]?.[colCondAttr.key]
							)
						) {
							a1.push(col);
						} else {
							a2.push(col);
							if (Array.isArray(data[col.linked_table]?.[col.key])) a2DefValues[col.key] = [NAOption];
							else a2DefValues[col.key] = NAOption;
						}
					});
					setCurrentConditionalAttr(condAttrColVal);
					setArr1(a1);
					setArr2(a2);
					setData({ ...data, [attrGrp.linked_table]: { ...data[attrGrp.linked_table], ...a2DefValues } });
				} else setArr1(columns);
			}
		} else setArr1(columns);
	}, [data]);
	const [arr1, setArr1] = useState([]);
	const [arr2, setArr2] = useState([]);
	const [viewAll, setViewAll] = useState(false);
	const [currentConditionalAttr, setCurrentConditionalAttr] = useState();
	const handleShowAllClick = () => {
		setViewAll(!viewAll);
	};
	return (
		<Box width="100%">
			<Box
				display="flex"
				width={width ? width : "100%"}
				flexWrap="wrap"
				p={1}
				alignItems="flex-start"
				columnGap="1%"
				rowGap="2px">
				{arr1?.map((column) => {
					console.log(column, "[attrGrpId][attrGrpId]");

					let options = {};
					options = removeDropdownOptionsBasedonDependency(column, data, column?.[studioAttrValAssocObj], allAttributes);

					return (
						<RenderStyleInputField
							column={{ ...column, [studioAttrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={studioAttrValAssocObj}
							width={"24%"}
							longWidth={"48%"}
							// dependencyColData={}
							attrGrp={attrGrp}
							error={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
			<Box display="flex" justifySelf="end">
				<Button
					sx={{ marginLeft: "auto" }}
					onClick={handleShowAllClick}
					endIcon={viewAll ? <ExpandLess fontSize="large" /> : <ExpandMore fontSize="large" />}>
					View {viewAll ? "Less" : "All"}
				</Button>
			</Box>
			<Box
				display={viewAll && arr2?.length ? "flex" : "none"}
				width={width ? width : "100%"}
				flexWrap="wrap"
				p={1}
				alignItems="flex-start"
				columnGap="1%"
				rowGap="2px">
				{arr2?.map((column) => {
					console.log(column, "[attrGrpId][attrGrpId]");
					let options = {};
					options = removeDropdownOptionsBasedonDependency(column, data, column?.[studioAttrValAssocObj], allAttributes);

					return (
						<RenderStyleInputField
							column={{ ...column, [studioAttrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={studioAttrValAssocObj}
							width={"24%"}
							longWidth={"48%"}
							// dependencyColData={}
							attrGrp={attrGrp}
							error={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
		</Box>
	);
};
const CreateModalProfile = () => {
	const { user } = AuthState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes, setSelectedModalProfile } = StudioDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();

	const navigate = useNavigate();

	const [newRowDetails, setNewRowDetails] = useState(() => {
		let obj = {};
		allAttributes
			.filter((row) => row?.collection_type === attributeCollectionTypes.MODAL_PROFILES.key)
			.forEach((attr) => {
				if (!obj[attr?.linked_table]) obj[attr?.linked_table] = {};
				obj[attr?.linked_table][attr?.key] = getColDefaultValue(attr);
			});
		return obj;
	});
	const [pageFiles, setPageFiles] = useState([]);
	const [errobj, setErrorObj] = useState({});
	const [images, setImages] = useState([]);
	const [imgModalOpen, setImgModalOpen] = useState(false);
	const handleAddImageClick = () => {
		setImgModalOpen(true);
	};
	const handleSaveImgClick = (Images) => {
		setImages([...Images]);
		return true;
	};
	const handleFileUpload = async (profileImages, pageFiles) => {
		// append formdata with multiple file and its name

		const uploadModalProfileImgs = async () => {
			const formData = new FormData();
			profileImages?.forEach((image) => {
				formData.append("modalProfileImages", image.file);
			});

			const res = await axios.post("/api/studio/upload_modal_profile_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			});

			return res.data.result;
		};
		const uploadFiles = async () => {
			if (pageFiles?.length) {
				const fileFormData = new FormData();

				pageFiles?.forEach((fileData) => {
					fileFormData.append("files", fileData[fileColumn.key]);
					fileFormData.append("fileMeta", JSON.stringify(fileData)); // corresponding metadata
				});
				const res = await axios.post("/api/upload/multiple_upload_to_rel_bucket", fileFormData, {
					headers: {
						"content-type": "multipart/form-data",
					},
				});
				return res.data.result;
			}
			return new Promise((resolve, reject) => {
				resolve([]);
			});
		};
		const [modalProfileImgs, uploadedFiles] = await Promise.all([uploadModalProfileImgs(), uploadFiles()]);

		return [modalProfileImgs, uploadedFiles];
	};

	const handleFormSubmit = async () => {
		setLoadingOpen(true);
		if (images.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one image",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		let pendingFields = [];
		allAttributes
			.filter(
				(row) =>
					row?.linked_table === studioAttrGroupLinkedTables.modal_profile.key &&
					row?.input_type !== inputTypes.AUTO_GENERATE.key
			)
			.forEach((attr) => {
				let obj = newRowDetails;
				if (obj[attr?.linked_table])
					if (
						isColumnDefault(attr, obj?.[attr?.linked_table]?.[attr?.key]) &&
						attr?.constraints[constraintsOptions.NOTNULL.key]
					)
						pendingFields.push(attr);
			});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			stage: productionStageOptions.DESIGNER.key,
			status: statusOptions.CREATED.key,
		};

		try {
			let [profileImages, uploadedFiles] = await handleFileUpload(images, pageFiles);
			console.log(profileImages, "gasddfghjfdghjk");

			// finding main Img Url
			images.forEach((row, i) => {
				console.log(images, profileImages, "jkshfsandgfhjjjkkkkk");
				if (row[isMainImg] === true) {
					profileImages[i][isMainImg] = true;
					profileImages[i]["url"] = profileImages[i]["publicUrl"];
				}
			});

			uploadedFiles = uploadedFiles.map((row) => {
				let dup = { ...row };
				delete dup["id"];
				return dup;
			});

			const body = newRowDetails;
			// for joining color & images

			// for joining shoot & images
			body[studioAttrGroupLinkedTables.modal_profile.key] = {
				...body[[studioAttrGroupLinkedTables.modal_profile.key]],
				...sysData,
				[modalProfileImagesAssocObj]: profileImages,
				[modalProfileFileAssocObj]: uploadedFiles,
			};

			// console.log("stylesty", body);

			const { data } = await axios.post("/api/studio/create_modal_profile", body);
			console.log("res.data", data);
			setSelectedModalProfile();
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Profile created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${productPagePath}?${modalProfileUrlKey}=${data?.result?.modal_profile_id}`);
			setLoadingOpen(false);
		} catch (error) {
			console.log(error, "ddsfdghjkl");
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		}
	};

	const handleFileAdd = async (newFileData) => {
		setPageFiles((prev) => [...prev, { ...newFileData, [modalProfileUrlKey]: "To be Uploaded" }]);
		return true;
	};

	async function handleDesignerFileDelete(fileData) {
		setPageFiles((prev) => prev.filter((row) => row?.id !== fileData?.id));

		return true;
	}

	return (
		<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
			<Stack>
				<Box display="flex" columnGap={1}>
					<Typography ba variant="subtitle1">
						User :
					</Typography>
					<PersonRounded />
					<Typography ba variant="subtitle1">
						{user.name}
					</Typography>
				</Box>
			</Stack>
			<Box
				display="flex"
				alignItems="center"
				height="30px"
				columnGap={1}
				sx={{
					backgroundColor: statusOptions["NEW"]?.color || yellow[400],
					color: "white",
					padding: "5px",
					borderRadius: "5px",
				}}>
				{statusOptions["NEW"]?.icon} <Typography> {statusOptions["NEW"]?.name}</Typography>
			</Box>

			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
			<Box display="flex" justifyContent="space-around" width="100%">
				{/* left */}
				<Stack>
					<Box display="flex" width="100%" pb={1} justifyContent="space-between">
						<Typography variant="h6">Images</Typography>
						{images?.length > 0 && (
							<Button
								sx={{ textTransform: "capitalize" }}
								onClick={handleAddImageClick}
								size="small"
								startIcon={<AddRounded />}
								variant="outlined">
								Add / Set Main Images
							</Button>
						)}
					</Box>
					<Box
						width={imgWidth}
						height={imgHeight}
						sx={{ border: `1px solid ${grey[200]}` }}
						display="flex"
						alignItems="center"
						justifyContent="center">
						{images.length === 0 ? (
							<Box>
								<Button size="large" startIcon={<AddRounded />} onClick={handleAddImageClick}>
									Add Images
								</Button>
							</Box>
						) : (
							<Box width={imgWidth} height={imgHeight} display="flex" flexWrap="wrap" rowGap={2}>
								<ImageSlider imgWidth={imgWidth} imgHeight={imgHeight} column="url" images={images} />
							</Box>
						)}
						{/* */}
					</Box>
				</Stack>
				<Divider orientation="vertical" flexItem />
				{/* right */}
				<Box sx={{ width: "76%" }}>
					{Object.keys(attrGroupsWithAttr)
						.reduce((acc, row) => {
							if (
								attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
								studioAttrGroupLinkedTables.modal_profile.key
							)
								acc.push(attrGroupsWithAttr[row]);
							return acc;
						}, [])
						?.map((row) => {
							return (
								<Box width="100%" pt={2}>
									<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
									{row?.data?.[attrConditionalDisplayColObj.key] ? (
										<RenderConditionalAttributeInputs
											columns={[...row[studioAttrGrpAttrAssocObj]]}
											setData={setNewRowDetails}
											data={newRowDetails}
											attrGrp={row}
											errObj={errobj}
											setErrorObj={setErrorObj}
										/>
									) : (
										<RenderAttributeInputs
											columns={[...row[studioAttrGrpAttrAssocObj]]}
											setData={setNewRowDetails}
											data={newRowDetails}
											attrGrp={row}
											errObj={errobj}
											setErrorObj={setErrorObj}
										/>
									)}
								</Box>
							);
						})}
				</Box>
			</Box>
			<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />

			{/* shoot Details Table Columns */}
			{Object.keys(attrGroupsWithAttr)
				.reduce((acc, row) => {
					if (
						attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
						studioAttrGroupLinkedTables.modal_profile_details.key
					)
						acc.push(attrGroupsWithAttr[row]);
					return acc;
				}, [])
				?.map((row) => {
					return (
						<Box width="100%" pt={2}>
							<Typography variant="h6">{row[attrGrpTableStrColumnsObj.name.key]}</Typography>
							{row?.data?.[attrConditionalDisplayColObj.key] ? (
								<RenderConditionalAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewRowDetails}
									data={newRowDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							) : (
								<RenderAttributeInputs
									columns={[...row[studioAttrGrpAttrAssocObj]]}
									setData={setNewRowDetails}
									data={newRowDetails}
									attrGrp={row}
									errObj={errobj}
									setErrorObj={setErrorObj}
								/>
							)}
						</Box>
					);
				})}

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%", mt: 2 }} /> */}
			{/* files Section */}
			<Box pt={"20px"} />
			<AddFiles
				addNewDefault={{ [styleImgDepartmentCol.key]: departments.STUDIO.key }}
				columns={fileColumns}
				handleAddFile={handleFileAdd}
				files={pageFiles}
				setFiles={setPageFiles}
				handleDelete={handleDesignerFileDelete}
			/>

			{/* <Divider flexItem orientation="horizontal" sx={{ width: "100%" }} /> */}

			{/* Submit Button */}
			<Box width="100%" display="flex" justifyContent="center" pb={2} pt={2}>
				<Button onClick={handleFormSubmit} variant="contained" margin="auto" size="large">
					Create Profile
				</Button>
			</Box>

			{/* add Images Modal */}
			{imgModalOpen && (
				<AddNewImageModal
					modalOpen={imgModalOpen}
					setModalOpen={setImgModalOpen}
					submitFunction={handleSaveImgClick}
					defaultImages={images}
				/>
			)}
		</Box>
	);
};

export default CreateModalProfile;
